import {GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {ClientAttributesState} from "@/store/cdp/client_attributes/types";

export const getters: GetterTree<ClientAttributesState, RootState> = {
    clientAttributes: state => Array.isArray(state.clientAttributes) ? state.clientAttributes : [],
    clientAttributeItem:state => state.clientAttributesItem,
}
